export default __webpack_public_path__ + "static/media/Koruri-Bold.8c6e6447.ttf";